import React from 'react'

export default function Loader() {
    return (
        <div className="spinner-border text-light" style={{ height: '1rem', width: '1rem' }} role="status">
            <span className="sr-only">Loading...</span>
        </div>
    )
}
